import React, { memo, useEffect, useState } from 'react'
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList'
import useDashboardFilterHook from '../Shared/useDashboardFilterHook'
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest'
import { enumUtil } from '../../../../utils/Enum'
import AmountFormatter from '../../../../utils/AmountFormatter'
import MultiLineChart from '../Charts/MultiLineChart'
import LineChart from '../Charts/LineChart'

const TimePeriodDD = [
  { value: "Weekly", display: "Weekly" },
  { value: "Monthly", display: "Monthly" },
]

const ChargelistDD = [
  { value: "DOS", display: "DOS" },
  { value: "Entry", display: "Entry" },
  { value: "Submitted", display: "Submitted" },
]

const PaymentFilterDD = [
  { value: "Entry", display: "Entry" },
  { value: "Check", display: "Check" },
  { value: "Deposit", display: "Deposit" },
  { value: "Posted", display: "Posted" },
]

const DeniedFilterDD = [
  { value: "DOS", display: "DOS" },
  { value: "Entry", display: "Claim" },
  { value: "Submitted", display: "Submitted" },
  { value: "Check", display: "Check" },
  { value: "Posted", display: "Payment" },
]

const API_URL = enumUtil.controller.Dashboard
const previousMonthName = new Date(new Date().setMonth(new Date().getMonth() - 1)).toLocaleString('default', { month: 'long' })

const PercentageField = ({ value }) => {
  const num = parseInt(value, 10) ? parseInt(value, 10) : 0;
  return (
    <div className={`d-flex align-items-center gap-1 ${num >= 0 ? 'profit_case' : 'loss_case'}`}>
      <i className={`${num >= 0 ? 'icon-Arrow-up fs-8' : 'icon-Arrow fs-15'}`}></i>
      <p className="text fs-10">{num}%</p>
      <p className="text fs-10">from {previousMonthName}</p>
    </div>
  )
}

const KPISection = memo((props) => {
  const { reloadData } = props;
  const [isFirstRender, setIsFirstRender] = useState(true);

  const [timePeriodName, setTimePeriodName] = useState('Weekly');
  const [chargeValueName, setChargeValueName] = useState('DOS');
  const [paymentValueName, setPaymentValueName] = useState('Check');
  const [deniedValueName, setDeniedValueName] = useState('Check');

  const [searchParam, setSearchParam] = useState({
    TimePeriod: TimePeriodDD[0]?.value,
    ChargeValue: ChargelistDD[0]?.value,
    PaymentValue: PaymentFilterDD[1]?.value,
    DeniedValue: DeniedFilterDD[3]?.value,
  });

  const [chargesLineChartData, setChargesLineChartData] = useState({});
  const [paymentsLineChartData, setPaymentsLineChartData] = useState({});
  const [adjustmentsLineChartData, setAdjustmentsLineChartData] = useState({});
  const [isLoadingLineChart, setIsLoadingLineChart] = useState({});

  const handleLineChartLoading = (type, val) => {
    setIsLoadingLineChart(prev => ({ ...prev, [type]: val }));
  };

  const setLineChartsData = (response, subSearchVal) => {
    let data = {};
    response.forEach(item => { data[item.group] = item; });

    if (subSearchVal) {
      if (subSearchVal === "ChargeValue") {
        handleLineChartLoading("ChargeValue", false);
        setChargesLineChartData({ Charges: data?.Charges });
      }
      if (["PaymentFor", "PaymentValue"].includes(subSearchVal)) {
        handleLineChartLoading("PaymentValue", false);
        setPaymentsLineChartData({ Payments: data?.Payments });
      }
      if (subSearchVal === "DeniedValue") {
        handleLineChartLoading("DeniedValue", false);
        setAdjustmentsLineChartData({ Adjustments: data?.Denied });
      }
    } else {
      setChargesLineChartData({ Charges: data?.Charges });
      setPaymentsLineChartData({ Payments: data?.Payments });
      setAdjustmentsLineChartData({ Adjustments: data?.Denied });
      setIsLoadingLineChart(prev => ({
        ...prev,
        "ChargeValue": false,
        "PaymentValue": false,
        "DeniedValue": false,
      }));
    }
  };

  const LoadData = (searchVal, subSearchVal) => {
    // searchVal is always 'Line Chart' or 'Payment Line Chart' (filter hook's Apply)
    if (subSearchVal) {
      if (subSearchVal === "ChargeValue") setChargesLineChartData({});
      else if (["PaymentFor", "PaymentValue"].includes(subSearchVal)) setPaymentsLineChartData({});
      else if (subSearchVal === "DeniedValue") setAdjustmentsLineChartData({});
    } else {
      setIsLoadingLineChart(prev => ({
        ...prev, TimePeriod: true,
        // ChargeValue: true, PaymentValue: true, DeniedValue: true 
      }));
      setChargesLineChartData({});
      setPaymentsLineChartData({});
      setAdjustmentsLineChartData({});
    }

    if (searchVal === 'Line Chart') setIsFirstRender(false);
    let mainTopFilterParams = {
      ...searchLineMainFilterModal?.SearchCriteria,
      TimePeriod: searchParam?.TimePeriod
    }
    ServerRequestProtected(API_URL + '/GetLineChartData', 'post', {
      "TableName": enumUtil.enumAPITableName.Dashboard,
      "SearchParam": 'Line Chart',
      SearchCriteria: {
        ChargeValue: searchParam?.ChargeValue,
        PaymentValue: searchParam?.PaymentValue,
        // PaymentFor: paymentLinePaymentForID,
        DeniedValue: searchParam?.DeniedValue,
        ...mainTopFilterParams,
      }
    }).then((response) => {
      setLineChartsData(response, subSearchVal);
    }).catch(() => {
    }).finally(() => {
      setIsLoadingLineChart(prev => ({ ...prev, TimePeriod: false, ChargeValue: false, PaymentValue: false, DeniedValue: false }));
    });
  };

  let [
    setOpenLineMainFilter,
    searchLineMainFilterModal,
    lineFilterMainDiv,
  ] = useDashboardFilterHook(
    LoadData,
    'Line Chart Main',
    () => { },
    null,
    null,
    () => {
      // -- onReset -- //
      setTimePeriodName('Weekly');
      setSearchParam({ ...searchParam, TimePeriod: TimePeriodDD[0]?.value, });
      if (TimePeriodDD[0]?.value !== searchParam?.PaymentValue) { handleLineChartLoading("TimePeriod", true); } // only show reload if value has changed from default value
    }
  )

  // let [
  //   setOpenPaymentLineFilter,
  //   searchPaymentLineFilterModal,
  //   paymentLineFilterDiv,
  //   setBasedOnDatePaymentLine,
  //   basedOnDatePaymentLine,
  //   setPaymentLinePaymentForID,
  //   paymentLinePaymentForID,
  // ] = useDashboardFilterHook(
  //   LoadData, 
  //   'Payment Line Chart', 
  //   () => {}, 
  //   null,
  //   null,
  //   () => {
  //     // -- onReset -- //
  //     setPaymentValueName('Check')
  //     setSearchParam({ ...searchParam, PaymentValue: PaymentFilterDD[1]?.value, });
  //     if (PaymentFilterDD[1]?.value !== searchParam?.PaymentValue) { handleLineChartLoading("PaymentValue", true); } // only show reload if value has changed from default value
  //   }
  // );

  useEffect(() => {
    LoadData("Line Chart");
  }, [reloadData, searchParam?.TimePeriod]);

  useEffect(() => {
    if (isFirstRender) return;
    LoadData("Line Chart", "ChargeValue");
  }, [searchParam?.ChargeValue]);

  useEffect(() => {
    if (isFirstRender) return;
    LoadData("Line Chart", "PaymentValue");
  }, [searchParam?.PaymentValue]);

  useEffect(() => {
    if (isFirstRender) return;
    LoadData("Line Chart", "DeniedValue");
  }, [searchParam?.DeniedValue]);

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === 'ChargeValue') { setChargeValueName(value); setSearchParam({ ...searchParam, ChargeValue: value }); }
    if (name === 'PaymentValue') { setPaymentValueName(value); setSearchParam({ ...searchParam, PaymentValue: value }); }
    if (name === 'DeniedValue') { setDeniedValueName(value); setSearchParam({ ...searchParam, DeniedValue: value }); }
  };

  const handleSelectedDataa = (selectedData, name, type) => {
    if (type === 'client' && selectedData) {
      if (name === 'TimePeriod') {
        setTimePeriodName(selectedData.display);
        setSearchParam({ ...searchParam, TimePeriod: selectedData.value + "" });
        if (selectedData.value !== searchParam?.TimePeriod) handleLineChartLoading(name, true);
      } else if (name === 'ChargeValue') {
        setChargeValueName(selectedData.display);
        setSearchParam({ ...searchParam, ChargeValue: selectedData.value + "" });
        if (selectedData.value !== searchParam?.ChargeValue) handleLineChartLoading(name, true);
      } else if (name === 'PaymentValue') {
        setPaymentValueName(selectedData.display);
        setSearchParam({ ...searchParam, PaymentValue: selectedData.value + "" });
        if (selectedData.value !== searchParam?.PaymentValue) handleLineChartLoading(name, true);
      } else if (name === 'DeniedValue') {
        setDeniedValueName(selectedData.display);
        setSearchParam({ ...searchParam, DeniedValue: selectedData.value + "" });
        if (selectedData.value !== searchParam?.DeniedValue) handleLineChartLoading(name, true);
      }
    } else {
      if (name === 'TimePeriod') { setTimePeriodName(''); setSearchParam({ ...searchParam, TimePeriod: "" }); }
      if (name === 'ChargeValue') { setChargeValueName(''); setSearchParam({ ...searchParam, ChargeValue: "" }); }
      if (name === 'PaymentValue') { setPaymentValueName(''); setSearchParam({ ...searchParam, PaymentValue: "" }); }
      if (name === 'DeniedValue') { setDeniedValueName(''); setSearchParam({ ...searchParam, DeniedValue: "" }); }
    }
    return selectedData;
  };

  return (
    <div className="row m-0 filter-row position-relative">
      <div className="p-0 d-flex justify-content-between align-items-center za_br_light br-bottom-1 pb-1-5 mb-06-px">
        <div className="d-flex align-items-center gap-2">
          <p className="heading text-black fs-15">Key Billing Activity</p>
          {/* <p className="za-dot text fst-italic fs-11">This Month</p> */}
        </div>
        <div className="d-flex align-items-center gap-2">
          {isLoadingLineChart?.TimePeriod ?
            (<div className="ar-small-loader last_loader">
              <div className="circle circle1"></div>
              <div className="circle circle2"></div>
            </div>) : <></>}
          <div className="w-85px">
            <SuperSearchList
              type="client"
              id='TimePeriod'
              name='TimePeriod'
              searchValue={timePeriodName}
              onChange={(e) => handleChange(e)}
              getSelectedData={handleSelectedDataa}
              data={TimePeriodDD}
              icon={'Simple'}
              sup_btn='sup_btn'
              sup_inp='superSearchVisitInp'
            />
          </div>
          <div className="position-relative payment-top-filter">
            <div className="app_tooltip left">
              <i className="icon-Icon-awesome-filter fs-16" onClick={() => setOpenLineMainFilter(prev => !prev)}></i>
              <p className="tool_tip xsm_text text-light">Filters</p>
            </div>
            {lineFilterMainDiv}
          </div>
        </div>
      </div>
      <div className="row align-items-center m-0 p-0">
        {/* Charges */}
        <div className="col-md-4 px-0">
          <div className="card_tabs">
            <div className="px-1-5 pt-2">
              <div className="d-flex align-items-center justify-content-between">
                <p className="text text-black fs-11">Charges</p>
                <div className="d-flex align-items-center gap-1">
                  {isLoadingLineChart?.ChargeValue ?
                    (<div className="ar-small-loader last_loader">
                      <div className="circle circle1"></div>
                      <div className="circle circle2"></div>
                    </div>) : <></>}
                  <div className="w-92px border-less-input">
                    <SuperSearchList
                      type="client"
                      id='ChargeValue'
                      name='ChargeValue'
                      searchValue={chargeValueName}
                      onChange={(e) => handleChange(e)}
                      getSelectedData={handleSelectedDataa}
                      data={ChargelistDD}
                      icon={'Simple'}
                      sup_btn='sup_btn'
                      sup_inp='superSearchVisitInp'
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <p className="heading fs-15 text-black">
                  <AmountFormatter amount={chargesLineChartData?.Charges?.CurrentMonthAmount} />
                </p>
                <PercentageField value={chargesLineChartData?.Charges?.Percentage} />
              </div>
              <div>
                {chargesLineChartData.Charges ? (
                  <MultiLineChart data={chargesLineChartData?.Charges} type={'Charges'} />
                ) : (
                  <div style={{ height: 155 }}></div>
                )}
              </div>
            </div>
            <div className="d-flex mt-1 justify-content-between footer-bg">
              <div>
                <p className="text ar-liht-color fs-10">Last Week</p>
                <p className="text"><AmountFormatter amount={chargesLineChartData?.Charges?.LastWeekAmount} /></p>
              </div>
              <div>
                <p className="text ar-liht-color fs-10">Last Month</p>
                <p className="text"><AmountFormatter amount={chargesLineChartData?.Charges?.PreviousMonthAmount} /></p>
              </div>
              <div>
                <p className="text ar-liht-color fs-10">YTD</p>
                <p className="text"><AmountFormatter amount={chargesLineChartData?.Charges?.YTD} /></p>
              </div>
            </div>
          </div>
        </div>

        {/* Payments */}
        <div className="col-md-4 px-1">
          <div className="card_tabs">
            <div className="px-1-5 pt-2">
              <div className="d-flex align-items-center justify-content-between">
                <p className="text text-black fs-11">Payments</p>
                <div className="d-flex align-items-center gap-1">
                  {isLoadingLineChart?.PaymentValue ?
                    (<div className="ar-small-loader last_loader">
                      <div className="circle circle1"></div>
                      <div className="circle circle2"></div>
                    </div>) : <></>}
                  <div className="w-92px border-less-input">
                    <SuperSearchList
                      type="client"
                      id='PaymentValue'
                      name='PaymentValue'
                      searchValue={paymentValueName}
                      onChange={(e) => handleChange(e)}
                      getSelectedData={handleSelectedDataa}
                      data={PaymentFilterDD}
                      icon={'Simple'}
                      sup_btn='sup_btn'
                      sup_inp='superSearchVisitInp'
                    />
                  </div>
                  {/* <div className="position-relative payment-top-filter">
                  <div className="app_tooltip left">
                    <i className="icon-Icon-awesome-filter fs-16" onClick={() => setOpenPaymentLineFilter(prev => !prev)}></i>
                    <p className="tool_tip xsm_text text-light">Filters</p>
                  </div>
                  {paymentLineFilterDiv}
                </div> */}
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <p className="heading fs-15 text-black">
                  <AmountFormatter amount={paymentsLineChartData?.Payments?.CurrentMonthAmount} />
                </p>
                <PercentageField value={paymentsLineChartData?.Payments?.Percentage} />
              </div>
              <div>
                {paymentsLineChartData.Payments ? (
                  <MultiLineChart data={paymentsLineChartData?.Payments} type={'Payments'} />
                ) : (
                  <div style={{ height: 155 }}></div>
                )}
              </div>
            </div>

            <div className="d-flex mt-1 justify-content-between footer-bg">
              <div>
                <p className="text ar-liht-color fs-10">Last Week</p>
                <p className="text"><AmountFormatter amount={paymentsLineChartData?.Payments?.LastWeekAmount} /></p>
              </div>
              <div>
                <p className="text ar-liht-color fs-10">Last Month</p>
                <p className="text"><AmountFormatter amount={paymentsLineChartData?.Payments?.PreviousMonthAmount} /></p>
              </div>
              <div>
                <p className="text ar-liht-color fs-10">YTD</p>
                <p className="text"><AmountFormatter amount={paymentsLineChartData?.Payments?.YTD} /></p>
              </div>
            </div>
          </div>
        </div>

        {/* Denied */}
        <div className="col-md-4 px-0">
          <div className="card_tabs">
            <div className="px-1-5 pt-2">
              <div className="d-flex align-items-center justify-content-between">
                <p className="text text-black fs-11">Denied</p>
                <div className="d-flex align-items-center gap-1">
                  {isLoadingLineChart?.DeniedValue ?
                    (<div className="ar-small-loader last_loader">
                      <div className="circle circle1"></div>
                      <div className="circle circle2"></div>
                    </div>) : <></>}
                  <div className="w-92px border-less-input">
                    <SuperSearchList
                      type="client"
                      id='DeniedValue'
                      name='DeniedValue'
                      searchValue={deniedValueName}
                      onChange={(e) => handleChange(e)}
                      getSelectedData={handleSelectedDataa}
                      data={DeniedFilterDD}
                      icon={'Simple'}
                      sup_btn='sup_btn'
                      sup_inp='superSearchVisitInp'
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <p className="heading fs-15 text-black">
                  <AmountFormatter amount={adjustmentsLineChartData?.Adjustments?.CurrentMonthAmount} />
                </p>
                <PercentageField value={adjustmentsLineChartData?.Adjustments?.Percentage} />
              </div>
              <div>
                {adjustmentsLineChartData.Adjustments ? (
                  <LineChart data={adjustmentsLineChartData.Adjustments} type={'Denied'} />
                ) : (
                  <div style={{ height: 155 }}></div>
                )}
              </div>
            </div>

            <div className="d-flex mt-1 justify-content-between footer-bg">
              <div>
                <p className="text ar-liht-color fs-10">Last Week</p>
                <p className="text"><AmountFormatter amount={adjustmentsLineChartData?.Adjustments?.LastWeekAmount} /></p>
              </div>
              <div>
                <p className="text ar-liht-color fs-10">Last Month</p>
                <p className="text"><AmountFormatter amount={adjustmentsLineChartData?.Adjustments?.PreviousMonthAmount} /></p>
              </div>
              <div>
                <p className="text ar-liht-color fs-10">YTD</p>
                <p className="text"><AmountFormatter amount={adjustmentsLineChartData?.Adjustments?.YTD} /></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default KPISection;
